import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LandingPageHeader from './LandingPageHeader';

function LandingPage({ onGetStarted }) {
  const navigate = useNavigate();
  // Image paths (replace with your actual images in public/)
  const turfImg = process.env.PUBLIC_URL + '/turf-offer.jpg';
  const battingImg = process.env.PUBLIC_URL + '/batting-offer.JPG';
  const ballsImg = process.env.PUBLIC_URL + '/balls-offer.jpg';
  const courtImg = process.env.PUBLIC_URL + '/court-offer.jpg';
  const upperDeckImg = process.env.PUBLIC_URL + '/upperdeck-offer.jpg';
  const legoImg = process.env.PUBLIC_URL + '/lego-offer.jpg';
  const galleryImages = [
    process.env.PUBLIC_URL + '/gallery1.JPG',
    process.env.PUBLIC_URL + '/gallery2.JPG',
    process.env.PUBLIC_URL + '/gallery3.JPG',
    process.env.PUBLIC_URL + '/gallery4.JPG',
    process.env.PUBLIC_URL + '/gallery5.JPG',
    process.env.PUBLIC_URL + '/gallery6.JPG',
  ];
  const [currentGallery, setCurrentGallery] = useState(0);

  const handlePrev = () => {
    setCurrentGallery((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };
  const handleNext = () => {
    setCurrentGallery((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };
  const handleThumbClick = (idx) => setCurrentGallery(idx);

  const handleNav = (section) => {
    if (section === 'home') {
      navigate('/');
    } else if (section === 'waiver') {
      navigate('/waiver');
    } else if (section === 'login') {
      navigate('/login');
    } else if (section === 'rental') {
      navigate('/rental');
    }
  };

  return (
    <div className="gsc-landing-root">
      <LandingPageHeader onNav={handleNav} />
      <main className="gsc-hero-main">
        <div className="gsc-hero-card">
                      <h1 className="gsc-hero-title">
                        Your Local Sports Hub offering an indoor turf<br />
                        fieldhouse and batting cages.
                      </h1>
                      <p className="gsc-hero-desc">
                        Happy to host a variety of activities on turf: baseball, softball, lacrosse, football, speed &amp; agility, group exercise. etc.
                      </p>
                      <button className="gsc-hero-btn" onClick={() => navigate('/login')}>
                        BOOK YOUR SPOT NOW
                      </button>
                      
                    </div>
                  </main>

                  {/* Explore Section */}
                  <section className="gsc-explore-section">
                    <h2 className="gsc-explore-title">EXPLORE GRANGER SPORTS COMPLEX</h2>
                    <p className="gsc-explore-desc">
                      Explore what lies within the Granger Sports Complex! Discover the excitement and energy that make this venue a hub for athletes and fans alike.
                    </p>
                    <div className="gsc-explore-video-wrapper">
                        <iframe
                          width="1112"
                          height="620"
                        src="https://www.youtube.com/embed/Jz0PvyTW5ZI"
                        title="Granger Sports Complex"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        ></iframe>
                    </div>
                  </section>

                  {/* About Section */}
                  <section className="gsc-about-section">
                    <h2 className="gsc-about-title">ABOUT GRANGER SPORTS COMPLEX</h2>
                    <div className="gsc-about-content">
                      <img className="gsc-about-img" src={process.env.PUBLIC_URL + '/about-sports.jpg'} alt="Sports equipment" />
                      <div className="gsc-about-text">
                        <h3>About the space</h3>
                        <p>
                          At Granger Sports Complex, we are dedicated to cultivating an inclusive environment where athletes of all levels can flourish, develop their skills, and passionately embrace the joy of sports. Offering indoor turf and indoor batting cages to rent 7 days a week.
                        </p>
                        <ul className="gsc-about-list">
                          <li>13,900 SQ ft building</li>
                          <li>72x120 SQ ft clearspan turf area with 22' ceilings</li>
                          <li>1,830 SQ ft dugout/warmup area</li>
                          <li>1,830 SQ ft upper level viewing area</li>
                          <li>2 Restrooms</li>
                          <li>3 full size batting cages</li>
                          <li>Coming soon - The court!!</li>
                        </ul>
                      </div>
                    </div>
                  </section>

                  {/* Welcome Section */}
                  <section className="gsc-welcome-section">
                    <div className="gsc-welcome-card">
                      <h2>Welcome to Granger Sports Complex</h2>
                      <p>
                        Are you a sports enthusiast, coach, personal trainer, or representative of a school or anyone looking for the ideal space to rent? Look no further! Our facility offers a versatile and well-equipped environment perfect for various activities, from training sessions to team practices. Whether you need a space for individual workouts, group classes, or large events, we have you covered. For more information or to discuss rental options, please email us, and let's bring your vision to life!
                      </p>
                      <a className="gsc-welcome-btn" href="mailto:info@grangersportscomplex.com">EMAIL</a>
                    </div>
                  </section>

                  {/* What We Offer Section */}
                  <section className="gsc-offer-section">
                    <h2 className="gsc-offer-title">WHAT WE OFFER AT GRANGER SPORTS COMPLEX</h2>
                    <div className="gsc-offer-list">
                      <div className="gsc-offer-row">
                        <img className="gsc-offer-img" src={turfImg} alt="Turf" />
                        <div className="gsc-offer-text">
                          <h3>The Turf @ Granger Sports Complex</h3>
                          <p>72x120 SQ ft clearspan turf area with 22' ceilings to allow year round training, empowering athletes in all turf sports to learn year round and elevate their game to new heights.</p>
                        </div>
                      </div>
                      <div className="gsc-offer-row reverse">
                        <img className="gsc-offer-img" src={battingImg} alt="Batting Cages" />
                        <div className="gsc-offer-text">
                          <h3>The Batting Cages @ Granger Sports Complex</h3>
                          <p>We provide 3 full size batting cages, empowering athletes to elevate their hitting skills and achieve their full potential.</p>
                        </div>
                      </div>
                      <div className="gsc-offer-row">
                        <img className="gsc-offer-img" src={courtImg} alt="Courts" />
                        <div className="gsc-offer-text">
                          <h3>Coming soon - The courts @ Granger Sports Complex</h3>
                          <p>In addition to our turf field and well-equipped batting cages, GSC is excited to announce that we will soon introduce a versatile sports court. This new addition will accommodate a variety of sports, including basketball and volleyball, providing athletes of all skill levels with the perfect space to develop and compete. Stay tuned for more details on the grand opening and additional features of our sports court!</p>
                        </div>
                      </div>
                      <div className="gsc-offer-row reverse">
                        <img className="gsc-offer-img" src={upperDeckImg} alt="Upper Deck" />
                        <div className="gsc-offer-text">
                          <h3>The Upper Deck</h3>
                          <p>The second floor viewing area is designed for both relaxation and entertainment. It includes a dedicated children’s entertainment space, complete with age-appropriate games and activities to keep the little ones engaged. For those looking to stay active, there are walking paths available, allowing visitors to enjoy a gentle workout while taking in the views. Additionally, the area is furnished with comfortable seating, providing a cozy spot for comfortable viewing.</p>
                        </div>
                      </div>
                    </div>
                  </section>

                  {/* Image Collection Section */}
                  <section className="gsc-gallery-section">
                    <h2 className="gsc-gallery-title">IMAGE COLLECTION</h2>
                    <div className="gsc-gallery-main" style={{ position: 'relative', alignItems: 'center' }}>
                      <button
                        aria-label="Previous"
                        onClick={handlePrev}
                        style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', zIndex: 2, background: 'none', border: 'none', fontSize: '2rem', color: '#fff', cursor: 'pointer' }}
                      >&#8592;</button>
                      <img
                        className="gsc-gallery-img"
                        src={galleryImages[currentGallery]}
                        alt={`Gallery ${currentGallery + 1}`}
                        style={{ margin: '0 auto', display: 'block' }}
                      />
                      <button
                        aria-label="Next"
                        onClick={handleNext}
                        style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', zIndex: 2, background: 'none', border: 'none', fontSize: '2rem', color: '#fff', cursor: 'pointer' }}
                      >&#8594;</button>
                    </div>
                    <div className="gsc-gallery-thumbs">
                      {galleryImages.map((img, idx) => (
                        <img
                          key={img}
                          className="gsc-gallery-thumb"
                          src={img}
                          alt={`Gallery thumb ${idx + 1}`}
                          style={{ border: idx === currentGallery ? '2px solid #fff' : 'none' }}
                          onClick={() => handleThumbClick(idx)}
                        />
                      ))}
                    </div>
                  </section>
                </div>
              );
            }

            export default LandingPage;
